import { connect } from 'react-redux';
import AuthenticatedRoute from '../../components/routes/AuthenticatedRoute';
import {
  selectors as AuthSelectors,
} from '../../reducers/auth';
import {
  selectors as UserSelectors,
} from '../../reducers/user';

const mapStateToProps = state => ({
  isEmailConfirmed: AuthSelectors.getConfirmationStatus(state),
  authenticated: AuthSelectors.getAuthenticatedStatus(state),
  userRole: UserSelectors.getUserRole(state),
});

export default connect(mapStateToProps)(AuthenticatedRoute);
